import React from 'react'

import { ExcessDeath as Component } from './component'
//
const ExcessDeath = props => {
  return <Component {...props} />
}
export default ExcessDeath
